<script setup lang="ts">
/**
 * UI-kit component
 * Category: Footers
 * Name: FooterTrustSeal
 * FIGMA: https://www.figma.com/design/NgI2cVJkWODrgnOBHO3Zed/Strapi-Builder--DS-?node-id=3065-809
 *
 * A 32px-tall trust seal for the footer's "100% safe & secure" row — self-contained
 * art on the footer surface, no plate behind it (unlike the payment chips). Ships as
 * committed Figma exports. seal=steam is 46x32 while the other three are 32x32 —
 * per the design handoff this needs a designer confirmation (flagged in GRWT-187);
 * the component renders each seal at its exported aspect. Seal order is free.
 * Local implementation of the Figma DS component missing from @brighterly/lib-lumee-ui (dsGap).
 */
// types
import type { FooterTrustSealProps } from '../types/interfaces'
// hooks
import { useFooterTrustSeal } from '../composables/use-footer-trust-seal.hook'

defineOptions({
  name: 'FooterTrustSeal',
})

const props = defineProps<FooterTrustSealProps>()

const {
  refImage,
} = useFooterTrustSeal({ props })
</script>

<template>
  <img
    class="footer-trust-seal"
    :src="refImage.src"
    :alt="seal"
    :width="refImage.width"
    :height="refImage.height"
    loading="lazy"
  >
</template>

<style lang="scss" scoped src="../styles/_footer-trust-seal.scss" />
